/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AiFillBank } from 'react-icons/ai';
import { v4 as uuidv4 } from 'uuid';
import { BsInputCursorText } from 'react-icons/bs';
import { FaLanguage, FaSignature } from 'react-icons/fa';
import { IoMail, IoCall, IoCalendar, IoRadioButtonOnOutline, IoCheckbox, IoToggle, IoLocation, IoImage } from 'react-icons/io5';
import {
  MdLink,
  MdOutlineAccessTime,
  MdOutlinePin,
  MdTextFields,
  MdOutlinePerson,
  MdOutlineBackup,
  MdOutlineCheckBox,
  MdSmartButton,
  MdFiberPin,
  MdOutlineArticle,
  MdContactPhone,
  MdMiscellaneousServices,
  MdPerson,
  MdViewAgenda,
} from 'react-icons/md';
import ButtonField from '../components/ButtonField';

import YesNoField from '../components/yesNo/YesNoField';
import { ComponentPanelsT, FormBuilderSchemaT, FormFieldT, TextWithTranslationsT } from '../types';
import { FORM_ADVANCED_SECTIONS, ADVANCED_SECTION_TITLES } from './formAdvancedSections';
import { COMPONENT_FIELD_LABEL } from './formComponentFieldLabelMap';
import { COMPONENT_FIELDS } from './formComponentFieldSchema';
import {
  FORM_COMPONENT_ADVANCED_INPUT_TYPE,
  FORM_COMPONENT_BASIC_INPUT_TYPE,
  FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE,
} from './formComponentInputTypeSchema';
import { ComponentFieldsT, ComponentInputTypeT, FormComponentAdvancedInputTypeT, FormComponentBasicInputTypeT } from './types';
import { FORM_BUILDER_TEXT } from './formBuilderText';
import { AddressField } from '../components/AddressField';
import { CheckBoxDisableField } from '../components/CheckBoxDisableField';
import { CheckBoxField } from '../components/CheckBoxField';
import { DateField } from '../components/DateField';
import { DocumentReviewField } from '../components/documentReview/DocumentReviewField';
import EmailField from '../components/EmailField';
import { ImageField } from '../components/ImageField';
import { LinkField } from '../components/LinkField';
import { MultiChoiceField } from '../components/MultiChoiceField';
import NumberField from '../components/NumberField';
import { PhoneField } from '../components/PhoneField';
import { RadioField } from '../components/RadioField';
import { SignatureField } from '../components/SignatureField';
import { TextField } from '../components/TextField';
import { TimeField } from '../components/TimeField';

type DefaultValueProps = Partial<Omit<FormFieldT, 'id' | 'order' | 'timestamp'>> & {
  inputType?: ComponentInputTypeT;
  field?: string;
};

interface GetSchemaValuesProps
  extends Pick<FormBuilderSchemaT, 'type' | 'icon' | 'component' | 'hidden' | 'section' | 'sectionTitle'> {
  defaultValue: DefaultValueProps | DefaultValueProps[];
  label: string;
  panel?: ComponentPanelsT;
}

function getSchemaValues({
  defaultValue,
  label: paletteLabelKey,
  icon,
  panel = 'basic',
  component,
  type,
  hidden = false,
  section,
  sectionTitle,
}: GetSchemaValuesProps): FormBuilderSchemaT {
  function processSingleDefaultValue(value: DefaultValueProps): FormFieldT {
    const defaultText = { en: '', fr: '' };
    const fieldSchemaLabel = value.label ??
      COMPONENT_FIELD_LABEL[paletteLabelKey as FormComponentBasicInputTypeT | ComponentFieldsT] ??
      COMPONENT_FIELD_LABEL[type as FormComponentBasicInputTypeT] ?? { en: paletteLabelKey, fr: paletteLabelKey };

    const baseSchema: FormFieldT = {
      timestamp: Date.now(),
      id: uuidv4(),
      required: true,
      order: 1, // Default, will be reassigned later
      isInfo: false,
      isFollowUp: false,
      optionList: null,
      followUpQuestionList: null,
      documentReview: null,
      disabled: false,
      isFrontEndOnly: false,
      hideFieldSelector: false,
      min: null,
      max: null,
      enableWorkPermit: null,
      link: null,
      parentSection: null,

      inputType: type,
      field: type,
      text: defaultText,
      label: fieldSchemaLabel as TextWithTranslationsT,
      section,
      sectionTitle,
    };
    const mergedWithInputValue: FormFieldT = {
      ...baseSchema,
      ...value,
    };

    mergedWithInputValue.inputType = value.inputType ?? type;
    mergedWithInputValue.field = value.field ?? type;
    mergedWithInputValue.text = value.text ?? defaultText;
    mergedWithInputValue.label = (value.label ?? fieldSchemaLabel) as TextWithTranslationsT;
    mergedWithInputValue.section = section || value.section;
    mergedWithInputValue.sectionTitle = sectionTitle || value.sectionTitle;

    return mergedWithInputValue;
  }

  const processedDefaultValue = Array.isArray(defaultValue)
    ? defaultValue.map(processSingleDefaultValue)
    : processSingleDefaultValue(defaultValue);

  return {
    type,
    component,
    props: {},
    defaultValue: processedDefaultValue,
    icon,
    label: paletteLabelKey,
    panel,
    hidden,
    section,
    sectionTitle,
  };
}

function addressValidatorApartmentNumber(sectionKey: FORM_ADVANCED_SECTIONS): FormFieldT {
  const parentID = uuidv4();
  const yesOptionId = uuidv4();
  const noOptionId = uuidv4();
  return {
    timestamp: Date.now(),
    id: parentID,
    inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo,
    required: true,
    text: FORM_BUILDER_TEXT.addressValidator.apartmentYN.text,
    order: 0,
    section: sectionKey,
    optionList: [
      { key: 'Yes', id: yesOptionId, text: { en: 'Yes', fr: 'Oui' } },
      { key: 'No', id: noOptionId, text: { en: 'No', fr: 'Non' } },
    ],
    isFollowUp: false,
    followUpQuestionList: [
      {
        timestamp: Date.now(),
        id: uuidv4(),
        inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
        required: true,
        optionId: yesOptionId,
        text: FORM_BUILDER_TEXT.addressValidator.apartment.text,
        parent: parentID,
        order: 1,
        label: COMPONENT_FIELD_LABEL.apartment,
        previewPlaceholders: { placeholder: 'Apartment Number', disableMinMax: true },
        isFollowUp: true,
        field: COMPONENT_FIELDS.addressLineTwo,
        section: sectionKey,
      } as FormFieldT,
    ],
    parentSection: null,
    field: FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo,
    label: COMPONENT_FIELD_LABEL.apartment,
  };
}

function emergencyContact(sectionKey: FORM_ADVANCED_SECTIONS): FormFieldT {
  const parentID = uuidv4();
  const yesOptionId = uuidv4();
  const noOptionId = uuidv4();
  const baseYesNoDefault = FORM_COMPONENT_BASIC_SCHEMAS.yesNo.defaultValue as FormFieldT; // Assuming single FormFieldT
  return {
    ...baseYesNoDefault,
    timestamp: Date.now(),
    id: parentID,
    text: FORM_BUILDER_TEXT.emergencyContact.yesNo.text,
    order: 0,
    section: sectionKey,
    optionList: [
      { key: 'Yes', id: yesOptionId, text: { en: 'Yes', fr: 'Oui' } },
      { key: 'No', id: noOptionId, text: { en: 'No', fr: 'Non' } },
    ],
    isFollowUp: false,
    followUpQuestionList: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.text.defaultValue as FormFieldT),
        timestamp: Date.now(),
        id: uuidv4(),
        inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
        optionId: yesOptionId,
        text: FORM_BUILDER_TEXT.emergencyContact.emergencyContactFirstName.text,
        parent: parentID,
        order: 1,
        label: COMPONENT_FIELD_LABEL.emergencyContactFirstName,
        isFollowUp: true,
        field: COMPONENT_FIELDS.emergencyContactFirstName,
        section: sectionKey,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.text.defaultValue as FormFieldT),
        timestamp: Date.now(),
        id: uuidv4(),
        inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
        optionId: yesOptionId,
        text: FORM_BUILDER_TEXT.emergencyContact.emergencyContactLastName.text,
        parent: parentID,
        order: 2,
        label: COMPONENT_FIELD_LABEL.emergencyContactLastName,
        isFollowUp: true,
        field: COMPONENT_FIELDS.emergencyContactLastName,
        section: sectionKey,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.phone.defaultValue as FormFieldT),
        timestamp: Date.now(),
        id: uuidv4(),
        inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.phone,
        required: true,
        optionId: yesOptionId,
        text: FORM_BUILDER_TEXT.emergencyContact.emergencyContactPhoneNumber.text,
        parent: parentID,
        order: 3,
        label: COMPONENT_FIELD_LABEL.emergencyContactPhoneNumber,
        isFollowUp: true,
        field: COMPONENT_FIELDS.emergencyContactPhoneNumber,
        section: sectionKey,
      },
    ].map((f) => f as FormFieldT), // Ensure array elements are FormFieldT
    field: COMPONENT_FIELDS.emergencyContact,
    label: COMPONENT_FIELD_LABEL.emergencyContact,
    parentSection: null,
  };
}

interface GenerateYesNoSchemaProps extends Pick<FormFieldT, 'text' | 'section' | 'label'> {
  field?: FormFieldT['field'];
  followUpQuestions: (optionIds: {
    yesOptionId: string;
    noOptionId: string;
  }) => Array<
    Partial<Omit<FormFieldT, 'isFollowUp' | 'id' | 'parent' | 'order' | 'timestamp'>> & { inputType: ComponentInputTypeT }
  >; // Ensure inputType is present
}

function generateYesNoSchema({
  text,
  section: sectionKey,
  field,
  label,
  followUpQuestions,
}: GenerateYesNoSchemaProps): FormFieldT {
  const parentID = uuidv4();
  const yesOptionId = uuidv4();
  const noOptionId = uuidv4();
  const baseYesNoDefault = FORM_COMPONENT_BASIC_SCHEMAS.yesNo.defaultValue as FormFieldT;

  const generatedFollowUps = followUpQuestions({ yesOptionId, noOptionId }).map((questionPartial, index) => {
    const baseFollowUpDefault = FORM_COMPONENT_BASIC_SCHEMAS[
      (questionPartial.inputType as FormComponentBasicInputTypeT) || FORM_COMPONENT_BASIC_INPUT_TYPE.text
    ]?.defaultValue as FormFieldT;
    return {
      ...baseFollowUpDefault,
      ...questionPartial,
      timestamp: Date.now(),
      id: uuidv4(),
      parent: parentID,
      order: index + 1,
      isFollowUp: true,
      section: sectionKey,
    } as FormFieldT;
  });

  return {
    ...baseYesNoDefault,
    timestamp: Date.now(),
    id: parentID,
    text,
    order: 0,
    section: sectionKey,
    optionList: [
      { key: 'Yes', id: yesOptionId, text: { en: 'Yes', fr: 'Oui' } },
      { key: 'No', id: noOptionId, text: { en: 'No', fr: 'Non' } },
    ],
    isFollowUp: false,
    followUpQuestionList: generatedFollowUps,
    field: field || FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo,
    label,
    parentSection: null,
  };
}

// --- Basic Form Element Schemas ---
export const FORM_COMPONENT_BASIC_SCHEMAS: Record<FormComponentBasicInputTypeT, FormBuilderSchemaT> = {
  [FORM_COMPONENT_BASIC_INPUT_TYPE.text]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
    component: TextField,
    defaultValue: { min: 3, max: 500 },
    icon: BsInputCursorText,
    label: 'text',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.email]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.email,
    component: EmailField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.email.text,
      previewPlaceholders: { placeholder: 'Enter text here', disableMinMax: true },
    },
    icon: IoMail,
    label: 'email',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.phone]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.phone,
    component: PhoneField,
    defaultValue: { text: FORM_BUILDER_TEXT.phone.text },
    icon: IoCall,
    label: 'phone',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.link]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.link,
    component: LinkField,
    defaultValue: { link: { en: '', fr: '' } },
    icon: MdLink,
    label: 'link',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.date]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.date,
    component: DateField,
    defaultValue: {},
    icon: IoCalendar,
    label: 'date',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.time]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.time,
    component: TimeField,
    defaultValue: {},
    icon: MdOutlineAccessTime,
    label: 'time',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.number]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.number,
    component: NumberField,
    defaultValue: {},
    icon: MdOutlinePin,
    label: 'number',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.radio]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.radio,
    component: RadioField,
    defaultValue: {
      optionList: [
        { key: 'A', id: uuidv4(), text: { en: '' } },
        { key: 'B', id: uuidv4(), text: { en: '' } },
      ],
    },
    icon: IoRadioButtonOnOutline,
    label: 'radio',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.checkbox]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.checkbox,
    component: MultiChoiceField,
    defaultValue: {
      optionList: [
        { key: 'A', id: uuidv4(), text: { en: '' } },
        { key: 'B', id: uuidv4(), text: { en: '' } },
      ],
    },
    icon: IoCheckbox,
    label: 'checkbox',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.info]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.info,
    component: TextField,
    defaultValue: { isInfo: true },
    icon: MdTextFields,
    label: 'info',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.gender]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.gender,
    component: RadioField,
    defaultValue: {
      inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.radio,
      text: FORM_BUILDER_TEXT.gender.text,
      optionList: [
        { key: 'A', id: uuidv4(), text: { en: 'Female', fr: 'Femme' } },
        { key: 'B', id: uuidv4(), text: { en: 'Male', fr: 'Homme' } },
        { key: 'C', id: uuidv4(), text: { en: 'Non-Binary', fr: 'Non-Binaire' } },
        { key: 'D', id: uuidv4(), text: { en: 'Undeclared', fr: 'Non-Déclaré' } },
      ],
      field: COMPONENT_FIELDS.gender,
      label: { en: 'Gender', fr: 'Genre' },
    },
    icon: MdOutlinePerson,
    label: 'gender',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.yesNo,
    component: YesNoField,
    defaultValue: {
      label: { en: 'Yes/No', fr: 'Oui/Non' },
      optionList: [
        { key: 'Yes', id: uuidv4(), text: { en: 'Yes', fr: 'Oui' } },
        { key: 'No', id: uuidv4(), text: { en: 'No', fr: 'Non' } },
      ],
    },
    icon: IoToggle,
    label: 'yesNo',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.address]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.address,
    component: AddressField,
    defaultValue: { text: FORM_BUILDER_TEXT.address.text, field: 'basic_address' },
    icon: IoLocation,
    label: 'address',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.image]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.image,
    component: ImageField,
    defaultValue: { validations: { acceptType: ['image/jpg', 'image/jpeg', 'image/png'], maxFileSize: 2 * 1024 * 1024 } },
    icon: IoImage,
    label: 'image',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.file]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.file,
    component: ImageField,
    defaultValue: { validations: { acceptType: ['application/pdf'], maxFileSize: 2 * 1024 * 1024 } },
    icon: MdOutlineBackup,
    label: 'file',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.documentReview,
    component: DocumentReviewField,
    defaultValue: {
      documentReview: FORM_BUILDER_TEXT.documentReview,
    },
    icon: MdOutlineBackup,
    label: 'document',
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.singleCheckbox]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.singleCheckbox,
    component: CheckBoxField,
    defaultValue: {},
    icon: MdOutlineCheckBox,
    label: 'singleCheckbox',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.button]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.button,
    component: ButtonField,
    defaultValue: {},
    icon: MdSmartButton,
    label: 'button',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.bankAccountNumber]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.bankAccountNumber,
    component: NumberField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.bankAccountNumber.text,
      previewPlaceholders: { placeholder: '00 0000', disableMinMax: true },
      field: COMPONENT_FIELDS.bankAccountNumber,
    },
    icon: MdOutlinePin,
    label: 'bankAccountNumber',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.routingNumber]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.routingNumber,
    component: NumberField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.routingNumber.text,
      previewPlaceholders: { placeholder: '000000000', disableMinMax: true },
      field: COMPONENT_FIELDS.routingNumber,
    },
    icon: MdOutlinePin,
    label: 'routingNumber',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.branchTransitNumber]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.branchTransitNumber,
    component: NumberField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.branchTransitNumber.text,
      previewPlaceholders: { placeholder: '00000', disableMinMax: true },
      field: COMPONENT_FIELDS.branchTransitNumber,
    },
    icon: MdOutlinePin,
    label: 'branchTransitNumber',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.financialInstitutionNumber]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.financialInstitutionNumber,
    component: NumberField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.financialInstitutionNumber.text,
      previewPlaceholders: { placeholder: '000', disableMinMax: true },
      field: COMPONENT_FIELDS.financialInstitutionNumber,
    },
    icon: MdOutlinePin,
    label: 'financialInstitutionNumber',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.checkboxDisable]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.checkboxDisable,
    component: CheckBoxDisableField,
    defaultValue: { isFrontEndOnly: true },
    icon: MdOutlinePin,
    label: 'checkboxDisabled',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.correspondenceLanguage]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.correspondenceLanguage,
    component: RadioField,
    defaultValue: {
      inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.radio,
      text: FORM_BUILDER_TEXT.correspondenceLanguage.text,
      optionList: [
        { key: 'A', id: uuidv4(), text: { en: 'English', fr: 'Anglais' } },
        { key: 'B', id: uuidv4(), text: { en: 'French', fr: 'Français' } },
      ],
      field: COMPONENT_FIELDS.correspondenceLanguage,
      label: COMPONENT_FIELD_LABEL.correspondenceLanguage,
    },
    icon: FaLanguage,
    label: 'correspondenceLanguage',
    section: FORM_ADVANCED_SECTIONS.signature,
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.sin]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.sin,
    component: NumberField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.sin.text,
      label: COMPONENT_FIELD_LABEL.socialInsuranceNumber,
      previewPlaceholders: { placeholder: '000-000-000', disableMinMax: true },
      field: COMPONENT_FIELDS.socialInsuranceNumber,
    },
    icon: MdOutlinePin,
    label: 'sin',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.ssn]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.ssn,
    component: NumberField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.ssn.text,
      label: COMPONENT_FIELD_LABEL.socialSecurityNumber,
      previewPlaceholders: { placeholder: '000-000-000', disableMinMax: true },
      field: COMPONENT_FIELDS.socialSecurityNumber,
    },
    icon: MdOutlinePin,
    label: 'ssn',
    hidden: true,
  }),
  [FORM_COMPONENT_BASIC_INPUT_TYPE.signature]: getSchemaValues({
    type: FORM_COMPONENT_BASIC_INPUT_TYPE.signature,
    component: SignatureField,
    defaultValue: {
      text: FORM_BUILDER_TEXT.signature.text,
      label: COMPONENT_FIELD_LABEL.signature,
      field: COMPONENT_FIELDS.signature,
    },
    icon: FaSignature,
    label: 'signature',
    hidden: true,
  }),
} as const;

// --- Advanced Form Element Schemas (Grouped Fields) ---
const disableIds = {
  sinWorkPermit: 'sinWorkPermit',
  bankVoidCheque: 'bankVoidCheque',
};

export const FORM_COMPONENT_ADVANCED_SCHEMAS: Record<FormComponentAdvancedInputTypeT, FormBuilderSchemaT> = {
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.sinAdvanced]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.sinAdvanced,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.sin.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.sin.text,
        enableWorkPermit: true,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.checkboxDisable.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.permit.text,
        disabledId: disableIds.sinWorkPermit,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.radio.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.permitType.text,
        label: COMPONENT_FIELD_LABEL.workPermitType,
        field: COMPONENT_FIELDS.workPermitType,
        optionList: [
          { key: 'A', id: uuidv4(), text: { en: 'Work Permit', fr: 'Permis de travail' } },
          { key: 'B', id: uuidv4(), text: { en: 'Study Permit', fr: "Permis d'études" } },
          { key: 'C', id: uuidv4(), text: { en: 'Post-Graduation Work Permit', fr: 'Permis de travail postdiplôme' } },
        ],
        disabledId: disableIds.sinWorkPermit,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.date.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.endDate.text,
        label: { en: 'Permit end date', fr: "Date d'expiration du permis" },
        field: COMPONENT_FIELDS.workPermitEndDate,
        disabledId: disableIds.sinWorkPermit,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.needPermitPhotoInfo.text,
        disabledId: disableIds.sinWorkPermit,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.permitPhotoInfo.text,
        disabledId: disableIds.sinWorkPermit,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.image.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.sinAdvanced.permitPhoto.text,
        label: { en: 'Permit Image', fr: 'Image du permis' },
        field: COMPONENT_FIELDS.workPermitImageUrl,
        disabledId: disableIds.sinWorkPermit,
      },
    ],
    section: FORM_ADVANCED_SECTIONS.sin,
    sectionTitle: ADVANCED_SECTION_TITLES.sin,
    icon: MdFiberPin,
    label: 'sin',
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.ssnAdvanced]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.ssnAdvanced,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.ssn.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.ssnAdvanced.ssn.text,
      },
    ],
    section: FORM_ADVANCED_SECTIONS.ssn,
    sectionTitle: ADVANCED_SECTION_TITLES.ssn,
    icon: MdFiberPin,
    label: 'ssn',
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.signatureAdvanced]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.signatureAdvanced,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.signature.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.signatureAdvanced.text,
      },
    ],
    icon: FaSignature,
    label: 'finalSinature',
    panel: 'advanced',
    section: FORM_ADVANCED_SECTIONS.signature,
    sectionTitle: ADVANCED_SECTION_TITLES.signature,
    hidden: true,
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.documentPreview]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.documentPreview,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.documentReview.defaultValue as FormFieldT),
        documentReview: {
          ...((FORM_COMPONENT_BASIC_SCHEMAS.documentReview.defaultValue as FormFieldT).documentReview ?? ({} as any)),
          ...FORM_BUILDER_TEXT.documentPreview.codeofconductandethics.documentReview,
        },
        field: COMPONENT_FIELDS.codeofconductandethics,
        text: FORM_BUILDER_TEXT.documentPreview.codeofconductandethics.text,
        label: COMPONENT_FIELD_LABEL.codeofconductandethics,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.documentReview.defaultValue as FormFieldT),
        documentReview: {
          ...((FORM_COMPONENT_BASIC_SCHEMAS.documentReview.defaultValue as FormFieldT).documentReview ?? ({} as any)),
          ...FORM_BUILDER_TEXT.documentPreview.privacynoticeforemployees.documentReview,
        },
        field: COMPONENT_FIELDS.privacynoticeforemployees,
        text: FORM_BUILDER_TEXT.documentPreview.privacynoticeforemployees.text,
        label: COMPONENT_FIELD_LABEL.privacynoticeforemployees,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.documentReview.defaultValue as FormFieldT),
        documentReview: {
          ...((FORM_COMPONENT_BASIC_SCHEMAS.documentReview.defaultValue as FormFieldT).documentReview ?? ({} as any)),
          ...FORM_BUILDER_TEXT.documentPreview.electronicmonitoringpolicy.documentReview,
        },
        field: COMPONENT_FIELDS.electronicmonitoringpolicy,
        text: FORM_BUILDER_TEXT.documentPreview.electronicmonitoringpolicy.text,
        label: COMPONENT_FIELD_LABEL.electronicmonitoringpolicy,
      },
    ],
    section: FORM_ADVANCED_SECTIONS.documentPreview,
    sectionTitle: ADVANCED_SECTION_TITLES.documentPreview,
    icon: MdOutlineArticle,
    label: 'documentPreview',
    panel: 'advanced',
    hidden: true,
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.canadianBank]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.canadianBank,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.canadianBank.info.text,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.branchTransitNumber.defaultValue as FormFieldT),
        label: COMPONENT_FIELD_LABEL.branchTransitNumber,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.financialInstitutionNumber.defaultValue as FormFieldT),
        label: COMPONENT_FIELD_LABEL.financialInstitutionNumber,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.bankAccountNumber.defaultValue as FormFieldT),
        label: COMPONENT_FIELD_LABEL.bankAccountNumber,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.checkboxDisable.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.canadianBank.enableVoidCheque.text,
        disabledId: disableIds.bankVoidCheque,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.canadianBank.voidChequePhotoInfo.text,
        disabledId: disableIds.bankVoidCheque,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.canadianBank.photoInstruction.text,
        disabledId: disableIds.bankVoidCheque,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.image.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.canadianBank.voidChequePhoto.text,
        disabledId: disableIds.bankVoidCheque,
        label: COMPONENT_FIELD_LABEL.chequebookImageUrl,
        field: COMPONENT_FIELDS.chequebookImageUrl,
      },
    ],
    section: FORM_ADVANCED_SECTIONS.canadianBank,
    sectionTitle: ADVANCED_SECTION_TITLES.canadianBank,
    icon: AiFillBank,
    label: 'canadianBank',
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.americanBank]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.americanBank,
    component: null,
    defaultValue: [
      { ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT), text: FORM_BUILDER_TEXT.americanBank.info.text },
      { ...(FORM_COMPONENT_BASIC_SCHEMAS.routingNumber.defaultValue as FormFieldT), label: COMPONENT_FIELD_LABEL.routingNumber },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.bankAccountNumber.defaultValue as FormFieldT),
        label: COMPONENT_FIELD_LABEL.bankAccountNumber,
        text: FORM_BUILDER_TEXT.americanBank.bankAccountNumber.text,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.checkboxDisable.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.americanBank.enableVoidCheque.text,
        disabledId: disableIds.bankVoidCheque,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.americanBank.needPhotoInfo.text,
        disabledId: disableIds.bankVoidCheque,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.americanBank.photoInstruction.text,
        disabledId: disableIds.bankVoidCheque,
      },
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.image.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.americanBank.voidChequePhoto.text,
        disabledId: disableIds.bankVoidCheque,
        label: COMPONENT_FIELD_LABEL.chequebookImageUrl,
        field: COMPONENT_FIELDS.chequebookImageUrl,
      },
    ],
    section: FORM_ADVANCED_SECTIONS.americanBank,
    sectionTitle: ADVANCED_SECTION_TITLES.americanBank,
    icon: AiFillBank,
    label: 'americanBank',
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.earliestStartDate]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.earliestStartDate,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.date.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.earliestStartDate.text,
        label: COMPONENT_FIELD_LABEL.earliestAvailabilityDate,
        field: COMPONENT_FIELDS.earliestAvailabilityDate,
      },
    ],
    section: FORM_ADVANCED_SECTIONS.earliestStartDate,
    sectionTitle: ADVANCED_SECTION_TITLES.earliestStartDate,
    icon: IoCalendar,
    label: 'earliestStartDate',
    panel: 'advanced',
    hidden: true,
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.addressValidator]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.addressValidator,
    component: null,
    hidden: false,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.address.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.addressValidator.address.text,
        label: { en: 'Complete Address', fr: 'Adresse complète' },
        field: 'address',
      },
      addressValidatorApartmentNumber(FORM_ADVANCED_SECTIONS.addressValidator),
    ],
    section: FORM_ADVANCED_SECTIONS.addressValidator,
    sectionTitle: ADVANCED_SECTION_TITLES.completeAddress,
    icon: IoLocation,
    label: FORM_ADVANCED_SECTIONS.addressValidator,
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.emergencyContact]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.emergencyContact,
    component: null,
    defaultValue: [emergencyContact(FORM_ADVANCED_SECTIONS.emergencyContact)],
    section: FORM_ADVANCED_SECTIONS.emergencyContact,
    sectionTitle: ADVANCED_SECTION_TITLES.emergencyContact,
    icon: MdContactPhone,
    label: FORM_ADVANCED_SECTIONS.emergencyContact,
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.miscellaneous]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.miscellaneous,
    component: null,
    hidden: true,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.text.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.miscellaneous.contractDetailsWordings.text,
        field: COMPONENT_FIELDS.contractDetailsWordings,
        label: COMPONENT_FIELD_LABEL.contractDetailsWordings,
        previewPlaceholders: { placeholder: 'formBuilder.editorPlaceholder.text', disableMinMax: true },
      },
    ],
    section: FORM_ADVANCED_SECTIONS.miscellaneous,
    sectionTitle: ADVANCED_SECTION_TITLES.miscellaneous,
    icon: MdMiscellaneousServices,
    label: 'miscellaneous',
    panel: 'advanced',
  }),
  [FORM_COMPONENT_ADVANCED_INPUT_TYPE.fullName]: getSchemaValues({
    type: FORM_COMPONENT_ADVANCED_INPUT_TYPE.fullName,
    component: null,
    defaultValue: [
      {
        ...(FORM_COMPONENT_BASIC_SCHEMAS.info.defaultValue as FormFieldT),
        text: FORM_BUILDER_TEXT.fullName.info.text,
      },
      generateYesNoSchema({
        text: FORM_BUILDER_TEXT.fullName.firstNameYN.text,
        label: COMPONENT_FIELD_LABEL.legalFirstName,
        section: FORM_ADVANCED_SECTIONS.fullName,
        followUpQuestions: ({ noOptionId }) => [
          {
            inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
            text: FORM_BUILDER_TEXT.fullName.firstName.text,
            field: COMPONENT_FIELDS.firstName,
            label: COMPONENT_FIELD_LABEL.firstName,
            previewPlaceholders: { placeholder: 'Enter text here', disableMinMax: true },
            optionId: noOptionId,
            section: FORM_ADVANCED_SECTIONS.fullName,
          },
        ],
      }),
      generateYesNoSchema({
        text: FORM_BUILDER_TEXT.fullName.middleNameYN.text,
        label: COMPONENT_FIELD_LABEL.legalMiddleName,
        section: FORM_ADVANCED_SECTIONS.fullName,
        followUpQuestions: ({ yesOptionId }) => [
          {
            inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
            text: FORM_BUILDER_TEXT.fullName.middleName.text,
            field: COMPONENT_FIELDS.middleName,
            label: COMPONENT_FIELD_LABEL.middleName,
            previewPlaceholders: { placeholder: 'Enter text here', disableMinMax: true },
            optionId: yesOptionId,
            section: FORM_ADVANCED_SECTIONS.fullName,
          },
        ],
      }),
      generateYesNoSchema({
        text: FORM_BUILDER_TEXT.fullName.lastNameYN.text,
        label: COMPONENT_FIELD_LABEL.legalLastName,
        section: FORM_ADVANCED_SECTIONS.fullName,
        followUpQuestions: ({ noOptionId }) => [
          {
            inputType: FORM_COMPONENT_BASIC_INPUT_TYPE.text,
            text: FORM_BUILDER_TEXT.fullName.lastName.text,
            field: COMPONENT_FIELDS.lastName,
            label: COMPONENT_FIELD_LABEL.lastName,
            previewPlaceholders: { placeholder: 'Enter text here', disableMinMax: true },
            optionId: noOptionId,
            section: FORM_ADVANCED_SECTIONS.fullName,
          },
        ],
      }),
    ],
    section: FORM_ADVANCED_SECTIONS.fullName,
    sectionTitle: ADVANCED_SECTION_TITLES.fullName,
    icon: MdPerson,
    label: 'fullname',
    panel: 'advanced',
  }),
} as const;

export const FORM_COMPONENT_SCHEMAS = {
  ...FORM_COMPONENT_BASIC_SCHEMAS,
  [FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE.section]: getSchemaValues({
    type: FORM_COMPONENT_FORM_BUILDER_INPUT_TYPE.section,
    component: null,
    defaultValue: {},
    icon: MdViewAgenda,
    label: 'section',
    panel: 'page-element',
  }),
  ...FORM_COMPONENT_ADVANCED_SCHEMAS,
} as const;

export const getFormSchemaByInputType = (inputType: ComponentInputTypeT) => {
  return FORM_COMPONENT_SCHEMAS[inputType];
};
